
const AI_SUCCESS = "AI_SUCCESS";
const AI_CLEAR = "AI_CLEAR";

const initialState = {
    openResearch: false,
    saveTotalLeadCount: null,
    newFunction: null,
    pageFrom: null,
    openResearchData: null,
    openResearchType: null,
};

const aiDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case AI_SUCCESS:
            return {
                ...state,
                ...action.payload,
            };
        case AI_CLEAR:
            return { ...initialState };
        default:
            return state;
    }
};

// Action creators
const setAiData = (payload) => ({ type: AI_SUCCESS, payload });
const clearAiData = () => ({ type: AI_CLEAR });

export { setAiData, clearAiData, aiDataReducer };
